<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { SelectCitiesQueryDocument } from '$gql/graphql.js';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import AsyncSelect from '$components/Form/AsyncSelect.svelte';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, number | null>;
    export let placeholder: string = 'Ville';

    export let id: string | null = null;

    let className: string = '';
    export { className as class };

    export let country: string | null;

    const apollo = getContainer().apollo();

    let options: {
        label: string;
        value: number;
    }[] = [];

    async function loadOptions(q: string) {
        let list =
            (
                await apollo.query({
                    query: SelectCitiesQueryDocument,
                    variables: { maxPerPage: 100, page: 1, country, q },
                })
            ).data?.cities.results ?? [];

        options = list.map((c) => ({
            value: c.id,
            label: c.name,
        }));

        let result: typeof options = list.map((c) => ({
            value: c.id,
            label: c.name,
        }));

        return result;
    }

    $: effectiveId = id ?? form.getFieldId(field);
</script>

{#key country}
    <AsyncSelect
        {form}
        {field}
        {loadOptions}
        optionToValue={(o) => o.value}
        valueToOption={async (v) => options.find((o) => o.value == v) || null}
        valueToId={(v) => v}
        optionId={'value'}
        label={'label'}
        showChevron
        {placeholder}
        class={className}
        id={effectiveId}
    >
        <div slot="option" let:option class="p-4">
            {option.label}
        </div>
    </AsyncSelect>
{/key}
